/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Reports {


    import Dictionary = _.Dictionary;
    import BusinessTypeDetail = Meevo.Model.BusinessTypeDetail;
    import IReportControl = Meevo.Model.IReportControl;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export interface IReportCategory {
        id: number;
        displayName: string;
        desc: string;
    }

    export interface IValidationJson {
        MaxDateRange?: number;
        MaxDate?: string;
        MinDate?: string;
        ClientSelector_TBL?: number;
        MinClientSelector_TBL?: number;
        DateBack?: number;
        AtLeastOneCheckbox?: Array<string>;
        MaxDateCalendar?: number;
        MinDateCalendar?: number;
        RunReportFor?: Meevo.Components.Controls.RunReportFor;
        LimitDateRangeTo?: string;
        DateRangeLimitByControl?: string[];
        CheckedByDefault?: string[];
        ShowIfChecked?: { [key: string]: string[] };
    }

    export interface IVisibilityIsSetObj {
        controlName: string;
        value: any;
    }

    export interface IReportControlScope extends angular.IScope {
        criteria: Dictionary<any>;
        options: IReportControl;
        mainModel: any;
        parameterNames: Array<string>;
        form: any;
        selectedReport: Meevo.Model.IReportGeneral;
        securityAccess: SecurityAccessEnum;
        objectStateEnum: ObjectStateEnum;
        securityAccessEnum: any;
        ObjectStateEnum: any;
        friendlyReminder: Function;
        centralOfficeControl: boolean;
        validationJson?: IValidationJson;
        now: Date;
        startOfTheMonth: Date;
        locationId: number;
        openCloseHistoryModel?: any;
        visibilityByControlNames: { controlName: string; valueToHide: string | number | boolean; nullValue?: string | number | boolean | null;}[];
        employeeMoverCheckBoxContentKey?: string;
        mr080ShowSeconds?: boolean;
        allSelectedSecurityKey: string;
        visibilityIfSetArr: IVisibilityIsSetObj[];
        properties: _.Dictionary<any>;
        atLeastOneCheckbox(): boolean;
        showIfChecked(): boolean;
    }

    export interface IReportControlCriteria {
        readonly criteria: Dictionary<any>;
    }

    export interface IReportPurchaseOrder {
        purchaseOrderId: string;
        purchaseOrderNumber: string;
        purchaseOrderStateEnum: number;
        distributorId?: string;
    }

    export interface IReportLocation {
        storeNumber: string;
        externalId: string;
        currentMarketName: string;
        inTransfering: boolean;
        businessTypeName: string;
        id: number;
        storeName: string;
        locationId: number;
    }

    export interface IReportLocationGroup {
        businessTypeId: string;
        displayName: string;
        id: string;
        locationId: number;
        objectCreationType: number;
        objectState: number;
    }

    export interface IReportDistributor {
        ownedByLocationId: number;
        atLocationId: number;
        totalLocations: number;
        availableAtLocations: number;
        objectState: ObjectStateEnum;
        objectCreationType: number;
        id: string;
        locationId: number;
        displayName: string;
    }

    export interface IReportTax {
        displayName: string;
        dateUpdated: string;
        isActive: boolean;
        taxType_LId: string;
    }

    export interface IReportInventoryReturns {
        inventoryReturnHeader_LId: string;
        distributor_TId: string;
        dateCreated: string;
        totalReturnAmount: number;
        distributorDisplayName: string;
        inventoryReturnDisplayName: string;
    }

    export interface IReportEmployee {
        employeeCategories: { id: string; }[];
        id: string;
        displayName: string;
    }

    export interface IReportEmployeeCategory {
        id: string;
        displayName: string;
    }

    export interface IReportManufacturers {
        ownedByLocationId: number;
        atLocationId: number;
        totalLocations: number;
        availableAtLocations: number;
        objectState: ObjectStateEnum;
        objectCreationType: number;
        id: string;
        locationId: number;
        displayName: string;
    }

    export interface IReportVisitNoteType{
        ownedByLocationId: number;
        atLocationId: number;
        totalLocations: number;
        availableAtLocations: number;
        objectState: ObjectStateEnum;
        objectCreationType: number;
        id: string;
        locationId: number;
        displayName: string;
    }

    export interface IReportTeacher extends IReportEmployee {
    }

    export interface IReportStudent extends IReportEmployee  {
    }

    export interface IReportPointPromotion {

    }

    export interface IReportReferralType {
        id: string;
        objectState: ObjectStateEnum;
        displayName: string;
        homeLocationId: number;
    }

    export interface IReportDrawer {
        id: string;
        objectState: ObjectStateEnum;
        displayName: string;
        homeLocationId: number;
    }

    export interface IReportPaymentType {
        id: string;
        objectState: ObjectStateEnum;
        displayName: string;
        homeLocationId: number;
    }

    export interface IReportUser {
        id: string;
        displayName: string;
    }

    export interface IUser {
        id: string;
        displayName: string;
    }

    export interface IReportProductCategory {
        id: string;
        objectState: ObjectStateEnum;
        displayName: string;
        homeLocationId: number;
    }

    export interface IReportServiceCategory {
        availableToLocations: boolean;
        totalLocations: number;
        availableAtLocations: number;
        isOwner: boolean;
        businessTypeDetail: BusinessTypeDetail;
        languageId: number;
        displayName: string;
        id: string;
        objectCreationType: number;
        locationId: number;
        homeLocationId: number;
        objectState: number;
        entityVersion: number;
    }

    export interface IReportService {
        isEgift: boolean;
        categoryDisplayId: string;
        categoryDisplayName: string;
        categoryDetail: IReportServiceCategory;
        visitNoteTypeDetail: IReportServiceCategory;
        isTaxExempted: boolean;
        basePrice: number;
        baseShopCostPercentage: number;
        forceGenderPreference: boolean;
        frequencyOfVisit: number;
        canBePerformedOnMaleClient: boolean;
        canBePerformedOnFemaleClient: boolean;
        shouldBeIncludedInAvgTicket: boolean;
        doNotAllowStepTimingOverride: boolean;
        allowDoubleBook: boolean;
        doNotAllowTips: boolean;
        canBeBookedOnline: boolean;
        suppressWarnings: boolean;
        allowBookableWalkIn: boolean;
        isAddressRequired: boolean;
        isPrivate: boolean;
        showIsAddressRequired: boolean;
        isEventOnly: boolean;
        hasCheckoutCustomControls: boolean;
        isBookable: boolean;
        isAvailablePackagesOnly: boolean;
        ignoreEmployeeMinimum: boolean;
        isStorageUpdated: boolean;
        resourceType: number;
        contentType: string;
        availableToLocations: boolean;
        totalLocations: number;
        availableAtLocations: number;
        isOwner: boolean;
        businessTypeDetail: IReportServiceCategory;
        languageId: number;
        shortcut: string;
        displayName: string;
        id: string;
        objectCreationType: number;
        locationId: number;
        homeLocationId: number;
        objectState: number;
        entityVersion: number;
    }

    export interface IReportDP005Product extends IProductWithLabelCount {
        selected?: boolean;
        barCode: string;
        generalDisplayName: string;
        dP005ProductManufecturers: DP005ProductManufecturer[];
        dP005ProductCategories: DP005ProductCategory[];
    }

    export interface DP005ProductCategory {
        selected?: boolean;
        product_TId: string;
        product_TIds: string[];
        manufacturer_TId: string;
        manufacturer_TIds: string[];
        cat_TId: string;
        displayName: string;
        products: IReportDP005Product[];
    }

    export interface DP005ProductManufecturer {
        selected?: boolean;
        product_TId: string;
        product_TIds: string[];
        category_TIds: string[];
        category_TId: string;
        manufacturer_TId: string;
        displayName: string;
        products: IReportDP005Product[];
    }

    export interface IProductWithLabelCount {
        numberOfLabels: number;
        productDisplayName: string;
        product_TId: string;
        sku: string;
        variantDisplayName: string;
        variant_TId: string;
        barCode: string;
        generalDisplayName: string;
    }

    export interface IReportPayrollEmployee {
        employeeId: string;
        employeeFirstName: string;
        employeeLastName: string;
        id: string;
        employeeCode: string;
        displayName: string;
        objectStateEnum: number;
        reportPayrollEmployeeCategories: {
            employeeCatId: string;
            displayName: string;
            employeeId: string;
        }[];
    }

    export interface IReportFloorLocation {
        objectState: number;
        objectCreationType: number;
        id: string;
        locationId: number;
        displayName: string;
    }

    export interface IReportMerchantAccount {
        objectState: number;
        displayName: string;
    }

    export enum DP005LabelTypeEnum {
        avery4736 = 4736,
        avery8167 = 8167
    }
}
